<template>
  <v-layout column v-if="folders.length">
    <div class="subheading font-weight-bold my-2">
      {{ currentFolder.attached_folders.status === 'attached' ? "Apenso a:" : "Processos apensados:" }}
    </div>

    <v-layout
      class="item"
      v-for="folder in folders"
      :key="folder.id"
      justify-center
      align-center
      row
      @click="openFolder(folder.id)"
    >
      <v-flex class="pa-2" xs4>
        <v-menu open-on-hover top offset-y style="width: 100%">
          <v-layout class="folder-name" align-center row slot="activator">
            <img
              class="d-flex mx-3 folder-icon"
              :src="folderIcon"
              alt="Ícone de Pasta"
            >
            <v-layout column>
              <v-flex class="grey--text">
                <span class="caption">{{ folder.process_number }}</span>
              </v-flex>
              <v-flex class="font-weight-medium">
                <span>{{ folder.folder_type.name }}</span>
              </v-flex>
            </v-layout>
          </v-layout>

          <v-card dark class="pa-2" v-if="folder.subject">
            <span class="grey--text"> {{folder.subject}}</span>
          </v-card>
        </v-menu>
      </v-flex>

      <v-flex class="pa-2" xs3 xl4>
        <v-chip color="grey-lighten-2">
          <v-avatar size="16" color="white">
            <v-icon size="16" color="grey">mdi-briefcase</v-icon>
          </v-avatar>
          <strong class="grey--text text--darken-2 text-truncate" style="max-width: 25ch">
            {{ folder.entity.name }}
          </strong>
        </v-chip>
      </v-flex>

      <v-flex class="pa-2" xs3 xl2>
        <v-layout justify-center>
          <current-owner :folder="currentFolder" />
        </v-layout>
      </v-flex>

      <v-flex class="pa-2" xs2>
        <v-layout justify-center>
          <span class="caption"><term-component :folder="folder"></term-component></span>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import CurrentOwner from '@/components/inbox/CurrentOwner';
import TermComponent from '@/components/inbox/TermComponent';

export default {
  name: 'AttachedFoldersList',
  props: {
    currentFolder: {
      default: {},
      type: Object,
    },
  },
  components: {
    CurrentOwner,
    TermComponent,
  },
  data() {
    return {
      folderIcon: '/static/images/folder/folder-open-icon.svg',
    }
  },
  computed: {
    folders() {
      return this.$store.getters.activeFolder.attached_folders.folders;
    }
  },
  methods: {
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, '_blank');
    },
  }
}
</script>

<style scoped>
  .item {
    background: #f2f2f2;
    font-weight: 600 !important;
    border: 1px solid #E0E0E0;
    border-left: 3px solid #E0E0E0;
    box-sizing: border-box;
    border-radius: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/folder/list/AttachedFoldersList.vue